import React from 'react';
import '../App.css';

type MiniButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement>;

const MiniButton = React.forwardRef<HTMLButtonElement, MiniButtonProps>(
  ({ className, type = 'button', children, ...rest }, ref) => {
    const combinedClassName = ['mini-button', 'text-colour', className]
      .filter(Boolean)
      .join(' ');

    return (
      <button
        ref={ref}
        type={type}
        data-mini-button="T"
        className={combinedClassName}
        {...rest}
      >
        {children}
      </button>
    );
  },
);

MiniButton.displayName = 'MiniButton';

export default MiniButton;
